export const GET_PROJECT_TYPE_SUCCESS = 'GET_PROJECT_TYPE_SUCCESS';
export const GET_PROJECT_TYPE_FAILURE = 'GET_PROJECT_TYPE_FAILURE';
